// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Interfaces
export interface JurisdictionType {
    id: number;
    name: string;
    description: string;
}

@Injectable()
export class rsJurisdictionTypeSvc {

    constructor( private http: Http ) 
    {
        
    }

    getJurisdictionTypes( filter: string = "visible" ) : Observable<rsJurisdictionTypeSvc[]> {
        // Return our observable
        return Observable.create( observer => {
            // This method gets run when an object subscribes
            this.http.get( 'http://dfr.hydrocon.com/api/v1/jurisdictiontype/filters/' + filter, {
                withCredentials: true
            })
            .map( res => {
                return res.json().response.jurisdictiontype;
            }) 
            .subscribe( result => {
                // operation successful
                observer.next(result);
            }, err=> {
                // error encountered
                observer.error(err);
            }, () => {
                // operation complete
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/jurisdictiontype.service.ts